import { createIcon } from "../create-icon"

export const ReduceIcon = createIcon({
  title: "ReduceIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9H4C3.44772 9 3 8.55228 3 8C3 7.44772 3.44771 7 4 7H12Z"
      fill="currentColor"
    />
  ),
})

ReduceIcon.displayName = "ReduceIcon"
